import { Divider } from "primereact/divider";

export const SingleStepHeaders = ({ title, subtitle }: any) => {
  return (
    <>
      <h4 className="header-title margin-bottom-4">{title}</h4>
      <span className="text-base-regular">{subtitle}</span>
      <Divider className="margin-top-12 margin-bottom-0" />
    </>
  );
};
